import { FC, lazy, Suspense, useState } from 'react';

import { Spinner } from 'dibs-elements/src/Spinner';
import { useClientState } from 'dibs-react-hooks/exports/useClientState';

import styles from './LazyThumbVideo.scss';
import { SwiperItem_video } from './__generated__/SwiperItem_video.graphql';

type ThumbVideoProps = {
    video: SwiperItem_video;
    poster?: string;
};

const ThumbVideo = lazy(() =>
    import('./ThumbVideo').then(module => ({ default: module.ThumbVideo }))
);

const TileSpinner = (): JSX.Element => (
    <div className={styles.lazyVideoSpinner}>
        <Spinner />
    </div>
);

export const LazyThumbVideo: FC<ThumbVideoProps> = props => {
    const isClient = useClientState();
    const [hovered, setHovered] = useState(false);

    return isClient && hovered ? (
        <Suspense fallback={<TileSpinner />}>
            <ThumbVideo {...props} animateOnMount />
        </Suspense>
    ) : (
        <div onMouseEnter={() => setHovered(true)}>{props.children}</div>
    );
};
